import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { CardLinkOfferLocationsStore, CardLinkOfferLocationsState } from './card-link-offer-locations.store';

@Injectable({ providedIn: 'root' })
export class CardLinkOfferLocationsQuery extends QueryEntity<CardLinkOfferLocationsState> {
  constructor(protected store: CardLinkOfferLocationsStore) {
    super(store);
  }
}
